import type { Release } from '../releases.ts';

export default {
  version: '0.20.2',
  date: '2026-10-03',
  title: 'Upload button fix',
  summary: [
    'The Upload file picker lists every media type PRISM accepts, so MXF, MTS and BWF are no longer greyed out',
    'Fixed: choosing files with Upload sometimes did nothing',
  ],
  features: [
    'The file picker behind Upload now lists every media file type PRISM accepts, so files such as MXF, MTS and BWF are no longer greyed out',
  ],
  fixes: [
    'Choosing files with the Upload button sometimes did nothing: the picker closed and no upload started',
  ],
} satisfies Release;
